import React, { useEffect, useState } from "react";
import axios from "../../api/axios";

// MUI components
import {
  Grid,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  TablePagination,
  Paper,
  IconButton,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Snackbar,
  Typography,
  MenuItem,
} from "@mui/material";
import Icon from "@mui/material/Icon";

// Custom components
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

function Cadres() {
  const [Cadres, setCadres] = useState([]);
  const [salaryStructures, setSalaryStructures] = useState([]);
  const [staffGroups, setStaffGroups] = useState([]);

  const [openDialog, setOpenDialog] = useState(false);
  const [currentItem, setCurrentItem] = useState({
    id: null,
    name: "",
    salary_structures_id: "",
    staff_group_id: "",
  });

  const [snackbar, setSnackbar] = useState({ open: false, message: "" });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const fetchCadres = async () => {
    try {
      const response = await axios.get("/cadres");
      setCadres(response.data);
    } catch (err) {
      console.error("Failed to fetch cadres", err);
    }
  };

  const fetchDropdownData = async () => {
    try {
      const [salaryRes, staffRes] = await Promise.all([
        axios.get("/salary-structures"),
        axios.get("/staff-group"),
      ]);
      setSalaryStructures(salaryRes.data);
      setStaffGroups(staffRes.data);
    } catch (err) {
      console.error("Failed to fetch salary structures or staff groups", err);
    }
  };

  useEffect(() => {
    fetchCadres();
    fetchDropdownData();
  }, []);

  const handleSave = async () => {
    const payload = {
      name: currentItem.name,
      salary_structures_id: currentItem.salary_structures_id,
      staff_group_id: currentItem.staff_group_id,
    };

    try {
      if (currentItem.id) {
        await axios.put(`/cadres/${currentItem.id}`, payload);
        setSnackbar({ open: true, message: "Cadre updated successfully" });
      } else {
        await axios.post("/cadres", payload);
        setSnackbar({ open: true, message: "Cadre added successfully" });
      }
      fetchCadres();
      setOpenDialog(false);
      setCurrentItem({ id: null, name: "", salary_structures_id: "", staff_group_id: "" });
    } catch (err) {
      console.error(err);
      alert("Something went wrong.");
    }
  };

  const handleEdit = (item) => {
    setCurrentItem({
      id: item.id,
      name: item.name,
      salary_structures_id: item.salary_structures_id || "",
      staff_group_id: item.staff_group_id || "",
    });
    setOpenDialog(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this cadre?")) {
      try {
        await axios.delete(`/cadres/${id}`);
        fetchCadres();
        setSnackbar({ open: true, message: "Cadre deleted successfully" });
      } catch (err) {
        console.error("Delete failed", err);
      }
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const paginatedItems = Cadres.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox py={3}>
        <Grid container justifyContent="space-between" alignItems="center" px={2} mb={2}>
          <Typography variant="h5">Cadres</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenDialog(true)}
            sx={{ color: "#fff" }}
          >
            Add New
          </Button>
        </Grid>

        <TableContainer component={Paper} elevation={3} sx={{ borderRadius: 3 }}>
          <Table>
            {/* <TableHead>
              <TableRow sx={{ backgroundColor: "#f0f2f5" }}>
                <TableCell>#</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Salary Structure</TableCell>
                <TableCell>Staff Group</TableCell>
                <TableCell align="center">Actions</TableCell>
              </TableRow>
            </TableHead> */}

            <TableBody>
              {paginatedItems.length > 0 ? (
                paginatedItems.map((item, index) => (
                  <TableRow
                    key={item.id}
                    hover
                    sx={{ "&:last-child td, &:last-child th": { borderBottom: 0 } }}
                  >
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{item.name}</TableCell>
                    <TableCell>
                      {salaryStructures.find((s) => s.id === item.salary_structures_id)?.name ||
                        "--"}
                    </TableCell>
                    <TableCell>
                      {staffGroups.find((s) => s.id === item.staff_group_id)?.name || "--"}
                    </TableCell>
                    <TableCell align="center">
                      <IconButton color="primary" onClick={() => handleEdit(item)}>
                        <Icon>edit</Icon>
                      </IconButton>
                      <IconButton color="error" onClick={() => handleDelete(item.id)}>
                        <Icon>delete</Icon>
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={5} align="center" sx={{ padding: 3 }}>
                    No cadres found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          <TablePagination
            component="div"
            count={Cadres.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </TableContainer>
      </MDBox>

      {/* Add/Edit Dialog */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} fullWidth>
        <DialogTitle>{currentItem.id ? "Edit Cadre" : "Add New Cadre"}</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            label="Cadre Name"
            fullWidth
            margin="normal"
            value={currentItem.name}
            onChange={(e) => setCurrentItem({ ...currentItem, name: e.target.value })}
          />

          <TextField
            select
            label="Salary Structure"
            fullWidth
            margin="normal"
            value={currentItem.salary_structures_id}
            onChange={(e) =>
              setCurrentItem({ ...currentItem, salary_structures_id: e.target.value })
            }
          >
            <MenuItem value="">
              <em>-- Select Salary Structure --</em>
            </MenuItem>
            {salaryStructures.map((s) => (
              <MenuItem key={s.id} value={s.id}>
                {s.name}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            select
            label="Staff Group"
            fullWidth
            margin="normal"
            value={currentItem.staff_group_id}
            onChange={(e) => setCurrentItem({ ...currentItem, staff_group_id: e.target.value })}
          >
            <MenuItem value="">
              <em>-- Select Staff Group --</em>
            </MenuItem>
            {staffGroups.map((s) => (
              <MenuItem key={s.id} value={s.id}>
                {s.name}
              </MenuItem>
            ))}
          </TextField>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenDialog(false)}>Cancel</Button>
          <Button onClick={handleSave} variant="contained" color="primary" sx={{ color: "#fff" }}>
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={() => setSnackbar({ open: false, message: "" })}
        message={snackbar.message}
      />

      <Footer />
    </DashboardLayout>
  );
}

export default Cadres;
